import type { IssueSubtypeDto, IssueTypeDto } from '@issuemanager/api-client';
import { useEventCallback } from '@mui/material';
import { FakeDropdownBox } from '../../../filters';
import { IssueSubtypeMultipleSelector } from '../../../inputs';
import { useDataGridContext } from '../../data-grid-context';
import type { ExtendedGridColumnHeaderProps } from '../../types';
import { ContainerPopper } from './container-popper';

export function DataGridIssueSubtypeFilter(
  params: ExtendedGridColumnHeaderProps,
) {
  const context = useDataGridContext();
  const value: IssueSubtypeDto[] = context.filterModel[params.field] ?? [];
  const issueTypes: IssueTypeDto[] = context.filterModel.issueType ?? [];

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0 ? value.map((c) => c.name).join(', ') : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueSubtypeMultipleSelector
          open
          value={value}
          filterByIssueTypes={issueTypes.map((issueType) => issueType.name)}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
